/**
 * Get the appropriate SharePoint redirect URI based on current environment
 */
export const getSharePointRedirectUri = () => {
  const hostname = window.location.hostname
  const origin = window.location.origin

  // Check if we're in development/local environment
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // For localhost, Azure AD requires localhost specifically
    return process.env.REACT_APP_SHAREPOINT_REDIRECT_URI_LOCAL || 'http://localhost:3000/sharepoint/callback'
  }

  // Check for development/staging domain
  if (hostname.includes('artificially.test') || hostname.includes('staging')) {
    return process.env.REACT_APP_SHAREPOINT_REDIRECT_URI_DEV || `${origin}/sharepoint/callback`
  }

  // Production environment
  if (process.env.REACT_APP_SHAREPOINT_REDIRECT_URI_PROD) {
    return process.env.REACT_APP_SHAREPOINT_REDIRECT_URI_PROD
  }

  // Fallback to current origin
  return `${origin}/sharepoint/callback`
}

/**
 * Get the appropriate API URL based on current environment
 */
export const getApiUrl = () => {
  const hostname = window.location.hostname

  // Use environment variable if available
  if (process.env.REACT_APP_API_URL) {
    // For localhost frontend, make sure API calls go to localhost too
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return process.env.REACT_APP_API_URL.replace(/bp\.artificially\.test/g, 'localhost')
    }
    return process.env.REACT_APP_API_URL
  }

  // Fallback logic
  const port = window.location.port
  const protocol = window.location.protocol

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//localhost:8080/api`
  }

  // For other environments, assume API is on the same host with different port
  return `${protocol}//${hostname}:8080/api`
}